import { useEffect } from 'react';
import {
  useLocation, useNavigate,
} from 'react-router-dom';
import { useIsUserSignedInSelector } from '~/store/userData/userData.selectors';

export const useNavigateAfterLogin = () => {
  const navigate = useNavigate();
  const isUserSignedIn = useIsUserSignedInSelector();
  const { state } = useLocation();

  useEffect(() => {
    if (isUserSignedIn) {
      navigate(state?.from ?? '/');
    }
  }, [navigate, isUserSignedIn, state?.from]);
};
